/**
 * @license
 * Taken from https://github.com/acdlite/recompose
 * The MIT License (MIT)
 * Copyright (c) 2015-2016 Andrew Clark
 */
/**
 * @license
 * Taken from https://github.com/acdlite/recompose
 * The MIT License (MIT)
 * Copyright (c) 2015-2016 Andrew Clark
 */ export var getDisplayName = function (Component) {
    if (typeof Component === "string") {
        return Component;
    }
    if (!Component) {
        return undefined;
    }
    return Component.displayName || Component.name || "Component";
};
export default getDisplayName;

//# sourceMappingURL=getDisplayName.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/utils/getDisplayName.js
// module id = 77
// module chunks = 0